import { render } from "./Speakers.vue?vue&type=template&id=4fb77c46&scoped=true"
import script from "./Speakers.vue?vue&type=script&lang=ts"
export * from "./Speakers.vue?vue&type=script&lang=ts"

import "./Speakers.vue?vue&type=style&index=0&id=4fb77c46&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4fb77c46"

export default script